import React, { Component, Fragment } from 'react';
import Async from 'react-select';
import 'react-select/dist/react-select.css';
import Modal from 'react-responsive-modal';
import { MeetingNotesServices, DevelopmentServices, UtilityService, StyleServices } from "../../services";
import Switch from 'react-toggle-switch'
import AlertContainer from 'react-alert';
import Audit from "../../components/Common/audit";

//components
import PageHeader from '../../components/Page/PageHeader/PageHeader';
import Field from '../../components/Common/Field/Field'
import FileUpload from '../../components/FileUpload/FileUpload'

class DevelopmentProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdRefNo: "",
            fabricCount: [{
                original: false,
                fabricId: null,
                fabricPosition: null,
                devRefNumber: '',
                status: null,
                ETA: null
            }],
            trailRequired: false,
            blockRequired: false,
            trimCount: [{
                trimType: null,
                trimId: null,
                devRefNumber: '',
                status: null,
                ETA: null,
                comments: ''
            }],
            cuttingCount: [1],
            sewingCount: [1],
            manualQty: [1],
            dispatchCount: [1],
            garmentTypeForms: [1],
            meetingNoteValue: "",
            images: [],
            imageEdit: false,
            imageInfo: '',
            uploadNewImage: '',
            imageForModal: '',
            openModal: false,
            sampleQty: [1],
            dispatchQty: [1],

            embroideryArray2: [],
            designSheet: false,
            awaitingDevSample: false,
            markerRequired: false,
            smvAmmendment: false,
            mock: false,
            gramentTechTrail: false,

            date: null,
            dateReceivedAtMagnum: null,
            dateRequiredAtMagnum: null,
            sampleDate: null,
            awaitingDevSheet: '',
            fabricId: {},

            //options
            patternMasterOptions : [],

        }

    }

    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentWillMount() {
        DevelopmentServices.getPrefillInfo().then((response) => {
            if (response.message === "Operation Successful") {
                this.setState({ styleInfo: response.data.Style, fabricInfo: response.data.Fabric, trimInfo: response.data.Trims }, function () {
                    
                })
            }
        }).catch((error) => {

            UtilityService.errorMsg(this.msg)
        })

        this.getMagnumStyleNo('')
        this.getFabricNumber('')
        this.getTrimNumber('')
        
    }

    searchMeetingNote(e) {
        e.preventDefault();
        MeetingNotesServices.searchMeetingNotesBy(this.state.searchMeetingNotesBy, this.state.meetingNoteValue).then((response) => {
            if (response.status === 200) {
                this.setState({ meetingNotes: response.text.data.MN })
            }
        }).catch((error) => {

            UtilityService.errorMsg(this.msg)
        })
    }

    getMagnumStyleNo(value) {
        DevelopmentServices.getMagnumStyleNo(value).then((response) => {
            if (response.message === "Operation Successful") {
                let jsonData = []
                response.data.map((info, index) => {
                    let objData = {};
                    objData.label = info.styleNumber
                    objData.value = info._id
                    jsonData.push(objData)
                })
                this.setState({ styleNoInfo: jsonData })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    getFabricNumber(value) {
        DevelopmentServices.getFabricNumber(value).then((response) => {
            if (response.message === "List Displayed") {
                this.setState({ fabricNumberInfo: response.data })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    getTrimNumber(value) {
        DevelopmentServices.getTrimNumber(value).then((response) => {
            if (response.message === "List Displayed") {
                let jsonData = []
                response.data.map((info, index) => {
                    let objData = {};
                    objData.label = info.trimNumber
                    objData.value = info._id
                    jsonData.push(objData)
                })
                this.setState({ trimNumberInfo: jsonData })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    addEmbellishment(e) {
        e.preventDefault();
        let { manualQty } = this.state;
        manualQty.push(manualQty.length + 1);
        this.setState({ manualQty })
    }

    removeEmbellishment(e, index) {
        let { manualQty } = this.state;
        manualQty.splice(index, 1)
        this.setState({ manualQty })
    }

    createEmbellishment(e) {
        let aariData = {};
        aariData.chappa = this.state.chappa;
        aariData.reCutGuideStitch = this.state.reCut;
        let runningTime = {}
        runningTime.hh = this.state.hh;
        runningTime.mm = this.state.mm;
        aariData["runningTime"] = runningTime;
        let manualData = {};
        let time = {}

        time.hh = this.state.timehh;
        time.mm = this.state.timemm;
        manualData["time"] = time;
        manualData.numberOfBeads = this.state.numberOfBeads
        let tasselData = {};
        let trimObj = {};
        let trimData = []
        tasselData.beading = this.state.beading;
        tasselData.numberOfTassel = this.state.numberOfTassel;
        tasselData.method = this.state.method;
        this.state.manualQty.map((manual, index) => {
            trimObj["trimId"] = this.state[`manualTrim${index}`].value
            trimObj["quantity"] = parseInt(this.state[`manualQtyValue${index}`])
            trimData.push(trimObj);
            trimObj = {};

        })
        manualData["trimData"] = trimData
        let allInfo = {};
        allInfo["aariData"] = aariData;
        allInfo["tasselData"] = tasselData
        allInfo["manualData"] = manualData
        DevelopmentServices.createEmbelishment(allInfo, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ embellishmentId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    getPatternMaster(value, name) {
        DevelopmentServices.getEmployeId(value, name).then((response) => {
            if (response.message === "Operation Successful") {
                let jsonData = []
                response.data.map((info, index) => {
                    let objData = {};
                    objData.label = info.userId
                    objData.value = info._id
                    jsonData.push(objData)
                })
                this.setState({ patternMasterInfo: jsonData })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    imageUpload(e) {
        this.setState({ images: this.state.images.concat(e.target.files[0]) }, function () {
            let a = [];
            this.state.images.map((image, index) => {
                let b = {}
                b = image;
                b.imageName = `Sketch${++index}`
                b.imageDescription = ''
                a.push(b)
            })
            this.setState({ images: a })
        })
    }

    imageInfo(image, index) {
        this.setState({ imageInfo: image, imageIndex: index })
    }
    uploadNewImage(e) {
        let b = {};
        b = e.target.files[0];
        b.imageName = this.state.imageInfo.imageName;
        b.imageDescription = this.state.imageInfo.imageDescription;
        this.setState({ uploadNewImage: b })
    }

    updateImage() {
        this.state.images.map((image, index) => {
            if (index === this.state.imageIndex) {
                this.state.images[index] = this.state.uploadNewImage !== "" ? this.state.uploadNewImage : this.state.imageInfo
            }
        })
    }

    changeImageName(value) {
        let a = this.state.imageInfo;
        a.imageName = value;
        this.setState({ imageInfo: a })
    }

    changeImageDescription(value) {
        let a = this.state.imageInfo;
        a.imageDescription = value;
        this.setState({ imageInfo: a })
    }

    removeImage(image, indexVal) {
        let a = this.state.images;
        a.splice(indexVal, 1)
        this.setState({ images: a })
    }

    changeStyleNo = (styleNo) => {
        this.setState({ styleNo });
    }

    changeFabricNumber(e, index) {
        
        let fabricCount = [...this.state.fabricCount]
        fabricCount[index].fabricId = e.value
        this.setState({ fabricCount, ["fabricId" + index]: e });
    }

    changeTrimNumber(e, index) {
        let trimCount = [...this.state.trimCount]
        trimCount.trimId = e.value
        this.setState({ [`trim${index}`]: e , trimCount });
    }
    changeManualTrimNumber(e, index) {
        this.setState({ [`manualTrim${index}`]: e });

    }
    changePatternMaster = (patternMaster) => {
        this.setState({ patternMaster });
    }
    changePatternMasterDynamic(e, index) {
        this.setState({ [`patternMaster${index}`]: e });

    }
    changeCuttingMasterDynamic(e, index) {
        this.setState({ [`cuttingMaster${index}`]: e });

    }
    createProduct(e) {
        e.preventDefault();
        let data = {};
        data.embroideryTab = this.state.embroideryActive;
        data.MNId = this.state.meetingNoteId;
        data.magnumStyleId = this.state.styleNo.value;
        data.refImages = this.state.images;
        let form = document.forms['createProduct'];
        for (var i = 0; i < form.elements.length; i++) {
            data[form.elements[i].name] = form.elements[i].value
        }

        data.date = this.state.date
        data.dateReceivedAtMagnum = this.state.dateReceivedAtMagnum
        data.dateRequiredAtMagnum = this.state.dateRequiredAtMagnum

        DevelopmentServices.createProduct(data).then((response) => {
            if (response.message === "Successfully Updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ productId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    completeProduct(e) {
        DevelopmentServices.completeProduct(this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    createFabric(e) {
        e.preventDefault();
        let data = {};
        let info = [...this.state.fabricCount]

        // let form = document.forms['fabricForm'];
        // for (var i = 0; i < form.elements.length; i++) {
        //     data[i].ETA = this.state['ETA'+i]
        //     data[i].original = this.state['original'+i]
        //     data[form.elements[i].name] = form.elements[i].value
        //     if (Object.keys(data).length == 6) {
        //         data.original = this.state[`original${info.length}`] === true ? true : false
        //         data[i].ETA = this.state['ETA'+i]
        //         data[i].original = this.state['original'+i]
        //         info.push(data);
        //         data = {};
        //     }
        // }

        DevelopmentServices.createFabricForProduct(info, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ FabricId: response.data._id })

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    completeFabric(e) {
        e.preventDefault();
        DevelopmentServices.completeFabric(this.state.FabricId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    createTrim(e) {
        e.preventDefault();
        let data = {};
        let info = [...this.state.trimCount]
        // let form = document.forms['trimForm'];
        // for (var i = 0; i < form.elements.length; i++) {
        //     data[form.elements[i].name] = form.elements[i].value
        //     if (Object.keys(data).length == 7) {
        //         
        //         data.trimId = this.state[`trim${info.length}`].value
        //         data.ETA = this.state[`ETA${info.length}`]
        //         info.push(data);
        //         data = {};
        //     }
        // }
        
        
        DevelopmentServices.createTrimForProductDev(info, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ trimId: response.data._id })

            }
        }).catch((error) => {
            
            UtilityService.errorMsg(this.msg)
        })
    }

    completeTrim(e) {
        e.preventDefault();
        DevelopmentServices.completeTrim(this.state.trimId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    addCategoryCount(e, name) {
        if (name === "fabricCount") {
            let fabricCount = [...this.state.fabricCount]
            fabricCount.push({
                original: false,
                fabricId: null,
                fabricPosition: null,
                devRefNumber: '',
                status: null,
                ETA: null
            })
            this.setState({ fabricCount })
        }
        else if(name ='trimCount'){
            let trimCount = [...this.state.trimCount]
            trimCount.push({
                trimType: null,
                trimId: null,
                devRefNumber: '',
                status: null,
                ETA: null,
                comments: ''
            })
            this.setState({ trimCount })
        }
        else {
            let data = this.state[`${name}`];
            let length = this.state[`${name}`].length;
            data.push(length);
            this.setState({ [`${name}`]: data })
        }
    }

    removeCategoryCount(index, name) {
        let data = this.state[`${name}`];
        data.splice(index, 1);
        this.setState({ [`${name}`]: data })
    }

    addSize(e) {
        let { sampleQty } = this.state;
        sampleQty.push(this.state.sampleQty.length + 1);
        this.setState({ sampleQty: sampleQty })
    }

    removeSize(e, index) {
        alert(index)
        let { sampleQty } = this.state;
        
        sampleQty.splice(index, 1)
        

        this.setState({ sampleQty: sampleQty }, function () {
            
        })
    }

    addSizeForDispatch(e) {
        let { dispatchQty } = this.state;
        dispatchQty.push(this.state.dispatchQty.length + 1);
        this.setState({ dispatchQty: dispatchQty })
    }

    removeSizeForDispatch(e, index) {
        let { dispatchQty } = this.state;
        
        dispatchQty.splice(index, 1)
        

        this.setState({ dispatchQty: dispatchQty }, function () {
            
        })
    }

    createSample(e, index) {

        let info = {};
        let data = [];
        let countData = {};

        info._id = this.state.productId
        info.awaitingDevSample = this.state.awaitingDevSample;
        info.designSheet = this.state.designSheet
        info.awaitingDevSheet = this.state.awaitingDevSheet

        let form = document.forms["sampleForm"];
        for (var i = 0; i < form.elements.length; i++) {
            info[form.elements[i].name] = form.elements[i].value
            if (form.elements[i].name === "size" || form.elements[i].name === "quantity") {
                countData[form.elements[i].name] = parseInt(form.elements[i].value)
                if (Object.keys(countData).length == 2) {
                    data.push(countData);
                    countData = {};
                }
            }
        }

        info.date = this.state.sampleDate

        info["data"] = data


        DevelopmentServices.createSample(info).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    createPattern(e) {
        e.preventDefault();
        let info = {};
        info._id = this.state.productId
        info.patternMaster = this.state.patternMaster.value;
        info.blockRequired = this.state.blockRequired;
        info.trailRequired = this.state.trailRequired
        let form = document.forms["patternForm"];
        for (var i = 0; i < form.elements.length; i++) {
            info[form.elements[i].name] = form.elements[i].value

        }

        info.date = this.state.patternDate

        DevelopmentServices.createPattern(info).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ patternId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    completePattern(e) {
        e.preventDefault();
        DevelopmentServices.completePattern(this.state.patternId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    createGarment(e) {
        e.preventDefault();
        let info = {};
        let countData = {};
        let data = [];
        info._id = this.state.productId
        info.markerRequirements = this.state.markerRequired;
        info.smvAmmendment = this.state.smvAmmendment;
        info.trailRequired = this.state.gramentTechTrail;
        info.mock = this.state.mock;
        let form = document.forms["garmentForm"];
        for (var i = 0; i < form.elements.length; i++) {

            info[form.elements[i].name] = form.elements[i].value
            if (form.elements[i].name === "fitComments" || form.elements[i].name === "fab" || form.elements[i].name === "trims" || form.elements[i].name === "workManShip" || form.elements[i].name === "buyerChanges" || form.elements[i].name === "pat" || form.elements[i].name === "remarks") {

                countData[form.elements[i].name] = form.elements[i].value === "true" ? true : form.elements[i].value === "false" ? false : form.elements[i].value === "" ? false : form.elements[i].value

                if (Object.keys(countData).length == 7) {
                    data.push(countData);
                    countData = {};
                }
            }

        }
        info["sampleForm"] = data;
        
        DevelopmentServices.createGarment(info).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ garmentId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    addGarment(e) {
        let { garmentTypeForms } = this.state;
        garmentTypeForms.push(garmentTypeForms.length + 1);
        this.setState({ garmentTypeForms })
    }
    removeGarment(e, index) {
        let { garmentTypeForms } = this.state;
        garmentTypeForms.splice(index, 1);
        this.setState({ garmentTypeForms })
    }

    checkboxChange(e) {

        this.setState({ [e.target.id]: e.target.checked })
    }
    completeGarment(e) {

        DevelopmentServices.completeGarment(this.state.garmentId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    createCutting(e) {
        let data = {};
        let info = [];
        let form = document.forms["cuttingForm"]
        for (var i = 0; i < form.elements.length; i++) {
            data[form.elements[i].name] = form.elements[i].value;

            if (Object.keys(data).length === 4) {

                data.fabricIssues = this.state[`fabricIssue${info.length}`] === true ? true : false
                info.push(data);
                data = {};
            }
        }
        DevelopmentServices.createCutting(info, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ cuttingId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    completeCutting(e) {
        DevelopmentServices.completeCutting(this.state.cuttingId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    createSignOff(e) {
        DevelopmentServices.createSignOff(this.state.signOffDate, this.state.patternMaster, this.state.productId).then((response) => {
            if (response.message === "Successfully Stored") {
                UtilityService.successMsg(this.msg)
                this.setState({ signOffId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    completeSignOff(e) {
        DevelopmentServices.completeSignOff(this.state.signOffId).then((response) => {
            if (response.message === "Sign Off Completed") {
                UtilityService.successMsg(this.msg)
                this.setState({ signOffId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    createSewing(e) {
        e.preventDefault();
        let data = {};
        let form = document.forms["sewingForm"]
        let info = [];
        for (var i = 0; i < form.elements.length; i++) {
            data[form.elements[i].name] = form.elements[i].value;
            
            if (Object.keys(data).length === 6) {
                info.push(data);
                data = {};
            }
        }
        DevelopmentServices.createSewing(info, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ sewingId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }
    completeSewing(e) {
        DevelopmentServices.completeSewing(this.state.sewingId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    getProductImages = (refImages) => {
        this.setState({ images: refImages })
    }

    createDispatch(e) {
        e.preventDefault();
        let allSizes = {}
        let data = [];
        let objData = {};
        let form = document.forms["dispatchForm"]
        let info = [];
        for (var i = 0; i < form.elements.length; i++) {

            if (form.elements[i].name === "size" || form.elements[i].name === "quantity") {
                allSizes[form.elements[i].name] = form.elements[i].value
                if (Object.keys(allSizes).length === 2) {
                    data.push(allSizes);
                    allSizes = {};

                }
            }
            else {

                objData[form.elements[i].name] = form.elements[i].value;
                if (info[(info.length) - 1] !== undefined && info[(info.length) - 1].data !== undefined && info[(info.length) - 1].data !== []) {
                    data = []
                }

                if (Object.keys(objData).length === 6) {

                    objData["data"] = data
                    info.push(objData);
                    info[(info.length) - 1].magnum = this.state[`magnum${(info.length) - 1}`] === true ? true : false
                    objData = {};
                }
            }
        }
        DevelopmentServices.createDispatch(info, this.state.productId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)
                this.setState({ dispatchId: response.data._id })
            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })

    }

    completeDispatch(e) {
        DevelopmentServices.completeDispatch(this.state.dispatchId).then((response) => {
            if (response.message === "Successfully updated") {
                UtilityService.successMsg(this.msg)

            }
        }).catch((error) => {
            UtilityService.errorMsg(this.msg)
        })
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value })
    }

    imageUploadForSample = (e) => {
        StyleServices.imageUpload(e.target.files).then((response) => {
            if (response.status === 200) {
                this.setState({
                    awaitingDevSheet: response.text.data[0]
                })
            }
        }).catch((error) => {
            
        })
    }

    updateFabric = (name, value, index) => {
        
        let fabricCount = [...this.state.fabricCount]
        fabricCount[index][name] = value
        this.setState({ fabricCount })
    }

    updateTrim = (name,value,index) => {
        let trimCount = [...this.state.trimCount]
        trimCount[index][name] = value
        this.setState({ trimCount })
    }

    render() {

        let { styleInfo } = this.state;
        let { fabricInfo } = this.state;
        let { trimInfo } = this.state;
        return (
            <Fragment>
                <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
                <div class="right-section listFieldSetWrapper" id="development-product" >
                    <div class="row nopadding">
                        <PageHeader
                            history = {this.props.history}
                            header='Add Product'
                        />
                         <div className="pull-right">
                        <Audit _id={this.state.productId} />
                        </div>
                        <div class="col-md-12 nopadding mt-2 ">
                            <form id="createProduct">
                                <div class="card-filter" style={{ marginBottom: ".5%" }}>
                                    <div class="row" style={{ paddingBottom: "1%" }}>
                                        <div class="col-md-12 no-padding">
                                            <div class="sourcingTable">
                                                <table class="responsive-table w-75 mx-auto">
                                                    <tbody>
                                                        {this.state.pdRefNo !== "" &&
                                                            <tr>
                                                                <td><b>PD Req No.</b></td>
                                                                <td><input type="text" class="form-control" placeholder="SC-00001" readonly /></td>
                                                            </tr>}
                                                        <tr>
                                                            <td class="text-right"><b>Date</b></td>
                                                            <td>
                                                                <Field
                                                                    isFormGroup={false}
                                                                    inputType='date'
                                                                    value={this.state.date}
                                                                    inputName='date'
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </td>
                                                            <td class="text-right">
                                                                <b>Magnum Style No.</b>
                                                            </td>
                                                            <td>
                                                                <Async
                                                                    name="magnumStyleId"
                                                                    value={this.state.styleNo}
                                                                    onInputChange={(e) => this.getMagnumStyleNo(e)}
                                                                    onChange={this.changeStyleNo}
                                                                    placeholder="Find Style"
                                                                    options={this.state.styleNoInfo}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">
                                                                <b>Meeting Notes</b>
                                                            </td>
                                                            <td class="text-left">
                                                                <div class="col-md-10 no-padding">
                                                                    <input type="text" class="form-control" placeholder="" name="" value={this.state.MNId} />
                                                                </div>

                                                                <div class="col-md-2">
                                                                    <span class="popup-box" style={{ position: "absolute", borderRadius: 0 }}>
                                                                        <a href="#" style={{ borderRadius: 0 }} data-toggle="modal" data-target="#myModal"></a>
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td class="text-right">
                                                                <b>Request generated by</b>
                                                            </td>
                                                            <td class="text-left">
                                                                <input type="text" class="form-control" placeholder="userName" name="requestGeneratedBy" value={localStorage.getItem("userName")} disabled />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right">
                                                                <b>Product Development For</b>
                                                            </td>
                                                            <td class="text-left">
                                                                <input type="text" class="form-control" placeholder="MATLAN-GIRLSWEAR" name="productDevelopmentFor" />
                                                            </td>

                                                            <td class="text-right"><b>Origination Of Request</b></td>
                                                            <td class="text-left">
                                                                <input type="text" class="form-control" placeholder="" name="originationOfRequest" />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right"><b>Category</b></td>
                                                            <td class="text-left">
                                                                <select class="form-control" name="category">
                                                                    <option value="" >Select</option>
                                                                    <option value="Tassel" >Tassel</option>
                                                                    <option value="Construction" >Construction</option>
                                                                    <option value="Smocking" >Smocking</option>
                                                                    {/* <!-- <option >Embroidery</option> --> */}
                                                                </select>
                                                            </td>

                                                            <td class="text-right"><b>Embroidery</b></td>
                                                            <td class="text-left">
                                                                <Field
                                                                    isFormGroup={false}
                                                                    inputType='checkboxToggle'
                                                                    inputName='embroideryActive'
                                                                    value={this.state.embroideryActive}
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="text-right"><b>Date Reqd At Magnum</b></td>
                                                            <td class="text-left">
                                                                <Field
                                                                    isFormGroup={false}
                                                                    inputType='date'
                                                                    value={this.state.dateRequiredAtMagnum}
                                                                    inputName='dateRequiredAtMagnum'
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </td>

                                                            <td class="text-right"><b>Date Received At Magnum</b></td>
                                                            <td class="text-left">
                                                                <Field
                                                                    isFormGroup={false}
                                                                    inputType='date'
                                                                    value={this.state.dateReceivedAtMagnum}
                                                                    inputName='dateReceivedAtMagnum'
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="col-md-12 step-one">
                                                <div class="form-group w-75 mx-auto">
                                                    <label for="name" class="">Additional Info</label>
                                                    <textarea name="additionalInfo" class="form-control" rows="3" cols="80"></textarea>
                                                </div>
                                            </div>
                                            {/* <div class="col-md-12 nopadding">
                                                <div class="row m-0 w-75 mx-auto">
                                                    <div class="col-md-12 pull-right hide-customer-site-img mt-4">
                                                        <div class="upload-box" style={{ display: "block" }}>
                                                            <div class="file-field input-field">
                                                                <div class="btn px-3" style={{ marginBottom: 0 }}>
                                                                    <p style={{ fontSize: "11px" }} onChange={(e) => this.imageUpload(e)} >Upload Image</p>
                                                                    <input type="file" multiple="" onChange={(e) => this.imageUpload(e)} />
                                                                </div>
                                                                <div class="file-path-wrapper" style={{ display: "none" }}>
                                                                    <input class="file-path form-control" type="text" style={{ marginTop: "9px" }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 hide-customer-site" >
                                                    {this.state.imageEdit === true ?
                                                        <div class="row">
                                                            <div class="col-md-12 meeting-min-con">
                                                                <div class="table-site">
                                                                    <p class="text-center site-title"> <b>EDIT IMAGE</b> </p>
                                                                </div>
                                                                <div class="col-md-6 col-md-offset-3 product-form">
                                                                    <div class="col-md-12 step-one">
                                                                        <div class="form-group">
                                                                            <label for="dept">Image Name</label>
                                                                            <input type="text" class="form-control" placeholder="" value={this.state.imageInfo.imageName} onChange={(e) => this.changeImageName(e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12 step-one">
                                                                        <div class="form-group">
                                                                            <label for="address">Image Description</label>
                                                                            <textarea class="form-control" cols="30" rows="2" placeholder=""
                                                                                value={this.state.imageInfo.imageDescription} onChange={(e) => this.changeImageDescription(e.target.value)} ></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12 step-one">
                                                                        <div class="file-field input-field form-group">
                                                                            <div class="btn" style={{ marginBottom: "1.5%" }}>
                                                                                <span style={{ fontSize: "12px", color: "white" }}>File</span>
                                                                                <input type="file" onChange={(e) => this.uploadNewImage(e)} />
                                                                            </div>
                                                                            <div class="file-path-wrapper">
                                                                                <input class="file-path validate form-control" type="text" style={{ marginTop: "6px" }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <button type="button" class="primary" name="button" onClick={() => this.updateImage()}>Update Image</button> <a onClick={() => this.setState({ imageEdit: false })} style={{ color: "#fff", cursor: "pointer" }} class="primary site-add-go-back">Back</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <Fragment>
                                                            <div class="ref-images w-75 mx-auto" style={{ paddingLeft: 0, paddingRight: "0" }}>
                                                                <ul>
                                                                    {this.state.images !== undefined && Array.isArray(this.state.images) && this.state.images.length > 0 && this.state.images.map((image, index) =>
                                                                        <li>
                                                                            <a data-lightbox="image-1" onClick={() => this.setState({ openModal: true, imageForModal: image })}><img src={window.URL.createObjectURL(image)} /></a>
                                                                            <span><p class="img-label">{image.imageName === "" ? `Sketch${index + 1}` : image.imageName !== "" && image.imageName !== undefined && image.imageName.length > 7 ? image.imageName.substring(0, 7) : image.imageName}</p></span>
                                                                            <span><a onClick={() => this.setState({ imageEdit: true }, this.imageInfo(image, index))} class="btn-floating btn-small waves-effect waves-light black main-edit" title="Edit"><i class="material-icons">edit</i></a></span>

                                                                            <span><a class="btn-floating btn-small waves-effect waves-light black edit edit-img" title="img-edit" onClick={() => this.setState({ openModal: true, imageForModal: image })} ><i class="material-icons">photo</i></a></span>
                                                                            <span><a class="btn-floating btn-small waves-effect waves-light red delete" title="Delete" onClick={() => this.removeImage(image, index)}><i class="material-icons">close</i></a></span>
                                                                        </li>
                                                                    )}


                                                                </ul>
                                                            </div>


                                                        </Fragment>
                                                    }
                                                </div>
                                            </div> */}
                                            <FileUpload
                                                Heading="Upload Images"
                                                getRefImages={this.getProductImages}
                                                disabled={this.state.disabled}
                                                uploadedDocs={null}
                                            />

                                            <div class="col-md-12 no-padding text-center profile-btn">
                                                <button type="button" style={{ margin: '5px' }} class="primary" name="button" onClick={(e) => this.createProduct(e)}>Save</button>
                                                <button type="button" style={{ margin: '5px' }} class="primary" name="button" onClick={(e) => this.completeProduct(e)}>Complete</button>
                                                <button type="button" style={{ margin: '5px' }} class="primary" name="button">Edit</button>
                                            </div>
                                        </div>

                                        <div class="col-md-12 px-5 pt-3">
                                            <ul class="nav-locator">
                                                <li><label for="sample">Sample</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='sample' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Pattern</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='pattern' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Garment Tech</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='garment-tech' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Fabric</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='fabric' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Trim</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='trim' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>

                                                <li><label for="sample">Embellishment</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='embellishment' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Cutting</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='cutting' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Sewing</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='sewing' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Dispatch</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='dispatch' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li><label for="sample">Sign Off</label>
                                                    <div class="switch switch-mod">
                                                        <label>
                                                            <input value='sign-off' class="sample-opt-chckbox" type="checkbox" />
                                                            <span class="lever"></span>
                                                        </label>
                                                    </div>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </form>


                            {/*    SAMPLE MODULE     */}
                            <div class="card-filter meeting-min-con" id="sample" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <form name="sampleForm">
                                            <div class="wash-container">
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}><b>Sample</b></h6>
                                                    </div>
                                                    {/* <div class="samp-req-con"> */}
                                                    <div class="">
                                                        <div class="col-md-12 no-padding await-sec">
                                                            <div class="col-md-2 step-one pl-0">
                                                                <Field
                                                                    isFormGroup={true}
                                                                    inputType='checkboxToggle'
                                                                    inputName='awaitingDevSample'
                                                                    label='Awaiting Dev Sample'
                                                                    value={this.state.awaitingDevSample}
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </div>
                                                            <div class="col-md-2 step-one">
                                                                <Field
                                                                    isFormGroup={true}
                                                                    inputType='date'
                                                                    value={this.state.sampleDate}
                                                                    inputName='sampleDate'
                                                                    label='Date'
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </div>

                                                            <div class="col-md-3 step-one">
                                                                <Field
                                                                    isFormGroup={true}
                                                                    inputType='checkboxToggle'
                                                                    inputName='designSheet'
                                                                    label='Awaiting / Design Sheet'
                                                                    value={this.state.designSheet}
                                                                    onChange={this.updateDate}
                                                                    disabled={this.state.disabled}
                                                                />
                                                            </div>

                                                            <div class="col-md-3 step-one">
                                                                <div class="upload-box spec-box float-none mt-3" style={{ display: "block" }}>
                                                                    <div class="file-field input-field">
                                                                        <div class="btn" style={{ marginBottom: "0" }}>
                                                                            <p style={{ fontSize: "11px" }}>Upload</p>
                                                                            <input type="file" multiple onChange={(e) => this.imageUploadForSample(e)} />
                                                                        </div>
                                                                        <div class="file-path-wrapper" style={{ display: "none" }}>
                                                                            <input class="file-path form-control" type="text" style={{ marginTop: "9px" }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 px-1">
                                                            <div className="main-sample-size-box" >
                                                                <div className="row">
                                                                    {this.state.sampleQty !== undefined && Array.isArray(this.state.sampleQty) && this.state.sampleQty.map((value, index) =>
                                                                        <div class="col-md-3 size-mngr size-mngr-mod px-1 pr-4 mb-4" style={{ marginBottom: "5px" }}>
                                                                            <div class="col-4-shadow px-0">
                                                                                <div class="col-md-6 step-one mb-2">
                                                                                    <div class="form-group">
                                                                                        <label for="address">Size</label>
                                                                                        <select class="form-control select-box-min" name="size" >
                                                                                            <option value="slct">Select</option>
                                                                                            <option value={1}>1</option>
                                                                                            <option value={2}>2</option>
                                                                                            <option value={3}>3</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6 step-one mb-2">
                                                                                    <div class="form-group">
                                                                                        <label for="address">Qty</label>
                                                                                        <input type="number" min="0" class="form-control" name="quantity" />
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-2 add-address">
                                                                                    <a style={index === 0 ? { display: 'block' } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green add-multiple-sample-size-btn" onClick={(e) => this.addSize(e)}><i class="material-icons">add</i></a>
                                                                                    <a style={index !== 0 ? { display: 'block' } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn" onClick={(e) => this.removeSize(e, index)}><i className="material-icons">clear</i></a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div style={{ paddingBottom: '15px' }} className="multiple-sample-size-box" id="multiple-sample-size-box">
                                                            </div>
                                                            <div class="second-address-con" style={{ display: "none" }}>
                                                                <div class="col-md-3 size-mngr" style={{ marginBottom: "5px", marginLeft: "15px" }}>
                                                                    <div class="col-md-6 step-one">
                                                                        <div class="form-group">
                                                                            <label for="address">Size</label>
                                                                            <select class="form-control" name="">
                                                                                <option value="slct">Select</option>
                                                                                <option value="no.">1</option>
                                                                                <option value="no.">3</option>
                                                                                <option value="no.">6</option>

                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6 step-one">
                                                                        <div class="form-group">
                                                                            <label for="address">Qty</label>
                                                                            <input type="text" class="form-control" name="" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="add-address">
                                                                        <a class="btn-floating btn-small waves-effect waves-light red sec-close-btn"><i class="material-icons">clear</i></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 no-padding text-center mb-2">
                                                <button type="button" class="primary" name="button" onClick={(e) => this.createSample(e)}>Save</button>
                                                {/* <button type="button" class="primary" name="button" onClick={(e) => this.ccoSample(e)}>Save</button> */}
                                                {/* <button type="button" class="primary" name="button">Edit</button> */}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/* SAMPLE ENDS HERE */}

                            {/*  PATTERN STARTS HERE   */}


                            <div class="card-filter meeting-min-con" id="pattern" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <form name="patternForm">
                                            <div class="wash-container">
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}><b>Pattern</b></h6>
                                                    </div>
                                                    <div class="col-md-12 no-padding">
                                                        <div class="col-md-2 step-one">
                                                            <div class="form-group">
                                                                <label for="ref-no">Pattern Master Name</label>
                                                                <br />
                                                                <Async
                                                                    name="patternMaster"
                                                                    value={this.state.patternMaster}
                                                                    onInputChange={(e) => this.getPatternMaster(e, "patternMaster")}
                                                                    onChange={this.changePatternMaster}
                                                                    placeholder="Find Style"
                                                                    options={this.state.patternMasterInfo}

                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 step-one">
                                                            <Field
                                                                isFormGroup={true}
                                                                inputType='date'
                                                                value={this.state.patternDate}
                                                                inputName='patternDate'
                                                                label='Date'
                                                                onChange={this.updateDate}
                                                                disabled={this.state.disabled}
                                                            />
                                                        </div>

                                                        <div class="col-md-2 step-one">
                                                            <Field
                                                                isFormGroup={true}
                                                                inputType='checkboxToggle'
                                                                inputName='trailRequired'
                                                                label='Trail Required?'
                                                                value={this.state.trailRequired}
                                                                onChange={this.updateDate}
                                                                disabled={this.state.disabled}
                                                            />
                                                        </div>
                                                        <div class="col-md-2 step-one">
                                                            <div class="form-group">
                                                                <label for="">Existing Block Ref No.</label>
                                                                <input type="number" min="0" class="form-control" name="existingBlockRefNumber" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 step-one">
                                                            <Field
                                                                isFormGroup={true}
                                                                inputType='checkboxToggle'
                                                                inputName='blockRequired'
                                                                label='Have you followed the block required ?'
                                                                value={this.state.blockRequired}
                                                                onChange={this.updateDate}
                                                                disabled={this.state.disabled}
                                                            />
                                                        </div>
                                                        <div class="col-md-12 nopadding">
                                                            <div class="col-md-2 step-one">
                                                                <div class="form-group">
                                                                    <label for="">Block Ref No.</label>
                                                                    <input type="number" min="0" class="form-control" name="blockRefNumber" />
                                                                </div>
                                                            </div>

                                                            <div class="col-md-3 step-one">
                                                                <div class="form-group">
                                                                    <label for="remarks">Remarks</label>
                                                                    <input type="text" class="form-control" name="remarks" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 no-padding text-center profile-btn">
                                                <button type="button" class="primary" name="button" onClick={(e) => this.createPattern(e)}>Save</button>
                                                <button type="button" class="primary" name="button" onClick={(e) => this.completePattern(e)}>Complete</button>
                                                {/* <button type="button" class="primary" name="button">Edit</button> */}
                                                {/* <!-- <button type="button" class="primary" name="button">generate report</button>  --> */}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/*  PATTERN ENDS HERE   */}


                            {/*  GARMENT TECH STARTS HERE  */}

                            <div class="card-filter" id="garment-tech" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <form name="garmentForm">
                                            <div class="col-md-12 no-padding">
                                                <h6 class="dev-title"><b>Garment Technologist</b>
                                                    <span class="printer pull-right"><a><i class="fa fa-print"></i> Print</a></span></h6>
                                            </div>
                                            <div class="col-md-12 no-padding">
                                                <span class="text-center"><h6>SAMPLE RELEASE FORM</h6></span>
                                                <div class="srf-container">
                                                    <div class="table-container">
                                                        <table class="striped manage_permissions garment-tech-table">
                                                            <thead>
                                                                <tr>
                                                                    <th data-field="comment">Comments recieved from buyer</th>
                                                                    <th data-field="fab">Fab.</th>
                                                                    <th data-field="trim">Trims</th>
                                                                    <th data-field="work">Workmanship</th>
                                                                    <th data-field="change">Buyer's changes</th>
                                                                    <th data-field="pat">Pat.</th>
                                                                    <th data-field="remark">Remarks</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {this.state.garmentTypeForms !== undefined && Array.isArray(this.state.garmentTypeForms) && this.state.garmentTypeForms.length > 0 && this.state.garmentTypeForms.map((value, index) =>
                                                                    <Fragment>
                                                                        <tr class="mod-header">
                                                                            <th style={{ textAlign: "left" }}>Fit Comments</th>
                                                                            <th colspan="7"></th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <textarea name="fitComments" rows="4" cols="80" class="form-control" style={{ resize: "none" }}>

                                                                                </textarea>
                                                                            </td>
                                                                            <td>
                                                                                <p>
                                                                                    <input type="checkbox" id={"FAB" + index} class="filled-in" name="fab" value={this.state[`FAB${index}`]} onChange={(e) => this.checkboxChange(e)} />
                                                                                    <label for={"FAB" + index}></label>
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p>
                                                                                    <input type="checkbox" class="filled-in" id={"TRM" + index} name="trims" value={this.state[`TRM${index}`]} onChange={(e) => this.checkboxChange(e)} />
                                                                                    <label for={"TRM" + index}></label>
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p>
                                                                                    <input type="checkbox" class="filled-in" id={"MAN" + index} value={this.state[`MAN${index}`]} onChange={(e) => this.checkboxChange(e)} name="workManShip" />
                                                                                    <label for={"MAN" + index}></label>
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p>
                                                                                    <input type="checkbox" class="filled-in" id={"CHN" + index} value={this.state[`CHN${index}`]} onChange={(e) => this.checkboxChange(e)} name="buyerChanges" />
                                                                                    <label for={"CHN" + index}></label>
                                                                                </p>
                                                                            </td>
                                                                            <td>
                                                                                <p>
                                                                                    <input type="checkbox" class="filled-in" id={"PAT" + index} name="pat" value={this.state[`PAT${index}`]} onChange={(e) => this.checkboxChange(e)} />
                                                                                    <label for={"PAT" + index}></label>
                                                                                </p>
                                                                            </td>
                                                                            <td style={{ width: "25%" }}>
                                                                                <textarea name="remarks" rows="4" cols="80" class="form-control" style={{ resize: "none" }}>
                                                                                </textarea>
                                                                            </td>
                                                                            <td>
                                                                                <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-small waves-effect waves-light green pull-right add-a-new-tr-btn" onClick={(e) => this.addGarment(e)}><i class="material-icons">add</i></a>
                                                                                <a style={index !== 0 ? { display: "block" } : { display: "none" }} class="btn-small waves-effect waves-light red pull-right del-tr-btn" onClick={(e) => this.removeGarment(e, index)}><i class="material-icons">clear</i></a>
                                                                            </td>
                                                                        </tr>
                                                                    </Fragment>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 no-padding comments-wrapper">
                                                <div class="col-md-12 no-padding step-one">
                                                    <div class="form-group">
                                                        <label for="address">Garment Tech Comments</label>
                                                        <br />
                                                        <textarea type="text" rows="6" class="form-control" placeholder="" name="garmentTechComments"></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-md-10 col-md-offset-1 mb-3">
                                                    <div class="col-md-3 step-one">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType='checkboxToggle'
                                                            inputName='markerRequired'
                                                            label='Marker Requirement'
                                                            value={this.state.markerRequired}
                                                            onChange={this.updateDate}
                                                            disabled={this.state.disabled}
                                                        />
                                                    </div>
                                                    <div class="col-md-3 step-one">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType='checkboxToggle'
                                                            inputName='smvAmmendment'
                                                            label='SMV Ammendment'
                                                            value={this.state.smvAmmendment}
                                                            onChange={this.updateDate}
                                                            disabled={this.state.disabled}
                                                        />
                                                    </div>

                                                    <div class="col-md-3 step-one">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType='checkboxToggle'
                                                            inputName='gramentTechTrail'
                                                            label='Trail Required?'
                                                            value={this.state.gramentTechTrail}
                                                            onChange={this.updateDate}
                                                            disabled={this.state.disabled}
                                                        />
                                                    </div>

                                                    <div class="col-md-3 step-one">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType='checkboxToggle'
                                                            inputName='mock'
                                                            label='Mock'
                                                            value={this.state.mock}
                                                            onChange={this.updateDate}
                                                            disabled={this.state.disabled}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 no-padding text-center profile-btn">
                                                <button type="button" class="primary mr-2" onClick={(e) => this.createGarment(e)} name="button">Save</button>
                                                <button type="button" class="primary" name="button" onClick={(e) => this.completeGarment(e)}>Complete</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/*  GARMENT TECH ENDS HERE  */}

                            {/*  FABRIC STARTS HERE   */}

                            <div class="card-filter meeting-min-con" id="fabric" style={{ marginBottom: ".5%", display: "none" }}>

                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <form name="fabricForm">
                                            <div class="wash-container">
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}><b>Fabric</b>

                                                        </h6>
                                                    </div>
                                                    {this.state.fabricCount.map((value, index) =>
                                                        <div>
                                                            <div class="col-md-11 no-padding">

                                                                <div class="col-md-2 step-one pr-0">
                                                                    <Field
                                                                        isFormGroup={true}
                                                                        inputType='checkboxToggle'
                                                                        inputName={'original'}
                                                                        label='Original / Substitute'
                                                                        value={value.original}
                                                                        index={index}
                                                                        onChange={this.updateFabric}
                                                                        disabled={this.state.disabled}
                                                                    />
                                                                </div>

                                                                <div class="col-md-2 step-one">
                                                                    <div class="col-md-12 no-padding">
                                                                        <div class="form-group">
                                                                            <label for="fab-no">Fabric No.</label>
                                                                            <Async
                                                                                name="fabricId"
                                                                                value={this.state['fabricId' + index]}
                                                                                onInputChange={(e) => this.getFabricNumber(e)}
                                                                                onChange={(e) => this.changeFabricNumber(e, index)}
                                                                                placeholder="Find Fabric"
                                                                                options={this.state.fabricNumberInfo}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="ref-no">Fabric Position</label>
                                                                        <select class="form-control" name="fabricPosition"
                                                                            onChange={(e) => this.updateFabric(e.target.name, e.target.value, index)}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {fabricInfo !== undefined && fabricInfo.FABRICPOSITION !== undefined && Array.isArray(fabricInfo.FABRICPOSITION) && fabricInfo.FABRICPOSITION.length > 0 && fabricInfo.FABRICPOSITION.map((fabric, index) =>
                                                                                <option value={fabric._id}>{fabric.name}</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-2 step-one">
                                                                    <div class="col-md-12 no-padding">
                                                                        <div class="form-group">
                                                                            <label for="item">Dev Ref No.</label>
                                                                            <input type="number" min="0" class="form-control" placeholder="" name="devRefNumber"
                                                                                onChange={(e) => this.updateFabric(e.target.name, e.target.value, index)}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="ref-no">Status</label>
                                                                        <select class="form-control" name="status"
                                                                            onChange={(e) => this.updateFabric(e.target.name, e.target.value, index)}
                                                                        >
                                                                            <option value="style">Select</option>
                                                                            {fabricInfo !== undefined && fabricInfo.STATUS !== undefined && Array.isArray(fabricInfo.STATUS) && fabricInfo.STATUS.length > 0 && fabricInfo.STATUS.map((fabric, index) =>
                                                                                <option value={fabric._id}>{fabric.name}</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-2 step-one">
                                                                    <Field
                                                                        isFormGroup={true}
                                                                        inputType='date'
                                                                        value={value.ETA}
                                                                        inputName={'ETA'}
                                                                        label='ETA'
                                                                        index={index}
                                                                        onChange={this.updateFabric}
                                                                        disabled={this.state.disabled}
                                                                    />
                                                                </div>


                                                            </div>
                                                            <div class="col-md-1">
                                                                <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green pull-right mt-3" name="fabricCount" onClick={(e) => this.addCategoryCount(e, "fabricCount")}><i class="material-icons">add</i></a>
                                                                <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3" id="del-sample-size-btn" onClick={(e) => this.removeCategoryCount(index, "fabricCount")}><i className="material-icons">clear</i></a>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>

                                            </div>
                                        </form>
                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" name="button" onClick={(e) => this.createFabric(e)}>SAVE</button>
                                            <button type="button" class="primary" name="button" onClick={(e) => this.completeFabric(e)}>Complete</button>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            {/*  FABRIC ENDS HERE   */}
                            {/* TRIM STARTS HERE */}
                            <div class="card-filter meeting-min-con" id="trim" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <div class="wash-container">
                                            <div class="col-md-12 no-padding">
                                                <form id="trimForm">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title pl-3" style={{ paddingBottom: "10px" }}><b>trim</b>
                                                        </h6>
                                                    </div>
                                                    {this.state.trimCount !== undefined && Array.isArray(this.state.trimCount) && this.state.trimCount.length > 0 && this.state.trimCount.map((value, index) =>
                                                        <div>
                                                            <div class="col-md-11 no-padding">

                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="type">Trim Type</label>
                                                                        <br />
                                                                        <select class="form-control" name="trimType" onChange={(e) => this.updateTrim(e.target.name,e.target.value,index)}>
                                                                            <option value="type">Select</option>
                                                                            {trimInfo !== undefined && trimInfo.TRIMTYPE !== undefined && Array.isArray(trimInfo.TRIMTYPE) && trimInfo.TRIMTYPE.length > 0 && trimInfo.TRIMTYPE.map((trim, index) =>
                                                                                <option value={trim._id}>{trim.name}</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="col-md-12 no-padding">
                                                                        <div class="form-group">
                                                                            <label for="item">Trim Number</label>
                                                                            <br />
                                                                            {/* <!-- <span>(A short and catchy yet descriptive name for your product)</span>  --> */}
                                                                            <Async
                                                                                name="trimId"
                                                                                value={this.state[`trim${index}`]}
                                                                                onInputChange={(e) => this.getTrimNumber(e)}
                                                                                onChange={(e) => this.changeTrimNumber(e, index)}
                                                                                placeholder="Find Trim"
                                                                                options={this.state.trimNumberInfo}

                                                                            />
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="col-md-12 no-padding">
                                                                        <div class="form-group">
                                                                            <label for="item">Dev Ref No.</label>
                                                                            <br />
                                                                            {/* <!-- <span>(A short and catchy yet descriptive name for your product)</span>  --> */}
                                                                            <input type="number" min="0" class="form-control" placeholder="" name="devRefNumber" 
                                                                            onChange={(e) => this.updateTrim(e.target.name,e.target.value,index)}
                                                                            />
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                                <div class="col-md-2 step-one">
                                                                    <div class="form-group">
                                                                        <label for="type">Status</label>
                                                                        <br />
                                                                        <select class="form-control" name="status"
                                                                            onChange={(e) => this.updateTrim(e.target.name,e.target.value,index)}
                                                                        >
                                                                            <option value="type">Select</option>
                                                                            {trimInfo !== undefined && trimInfo.TRIMSTATUS !== undefined && Array.isArray(trimInfo.TRIMSTATUS) && trimInfo.TRIMSTATUS.length > 0 && trimInfo.TRIMSTATUS.map((trim, index) =>
                                                                                <option value={trim._id}>{trim.name}</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-4 step-one">
                                                                    <Field
                                                                        isFormGroup={true}
                                                                        inputType='date'
                                                                        value={value.ETA}
                                                                        inputName={`ETA`}
                                                                        label='ETA'
                                                                        index = {index}
                                                                        onChange={this.updateTrim}
                                                                        disabled={this.state.disabled}
                                                                    />
                                                                </div>
                                                                <div class="col-md-12 step-one">
                                                                    <div class="form-group">
                                                                        <label for="type">Comments</label>
                                                                        <br />
                                                                        <textarea name="comments" class="form-control" rows="4"
                                                                        onChange={(e) => this.updateTrim(e.target.name,e.target.value,index)}
                                                                        ></textarea>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="col-md-1">
                                                                <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green pull-right mt-4" onClick={(e) => this.addCategoryCount(e, "trimCount")}><i class="material-icons">add</i></a>
                                                                <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-4" id="del-sample-size-btn" onClick={(e) => this.removeCategoryCount(index, "trimCount")}><i className="material-icons">clear</i></a>
                                                            </div>
                                                        </div>
                                                    )}
                                                </form>
                                                {/* <!-- end of col-md-10 col-md-offset-1  --> */}
                                            </div>
                                        </div>
                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" name="button" onClick={(e) => this.createTrim(e)}>Save</button> <button type="button" class="primary" name="button" onClick={(e) => this.completeTrim(e)}>Complete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/*  TRIMS ENDS HERE   */}


                            {/*  EMBELLISHMENT STARTS HERE  */}

                            <div class="card-filter meeting-min-con" id="embellishment" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}><b>Embellishment Process </b></h6>
                                        <div class="col-md-12 no-padding">
                                            <div class="process-title sub_title">Embellishment</div>
                                            <div class="col-md-12 embroid-mul mt-0 mb-3">
                                                <div class="col-md-2 step-one text-left pl-1">
                                                    <p class="manage_permissions emb-chck">
                                                        <input type="checkbox" class="filled-in" id="filled-in-box6" value={this.state.aari} onChange={(e) => this.setState({ aari: !this.state.aari })} />
                                                        <label for="filled-in-box6">Aari</label>
                                                    </p>
                                                </div>
                                                <div class="col-md-2 step-one text-left pl-1">
                                                    <p class="manage_permissions emb-chck">
                                                        <input type="checkbox" class="filled-in" id="filled-in-box7" value={this.state.manual} onChange={(e) => this.setState({ manual: !this.state.manual })} />
                                                        <label for="filled-in-box7">Manual</label>
                                                    </p>
                                                </div>
                                                <div class="col-md-2 step-one text-left pl-1">
                                                    <p class="manage_permissions emb-chck">
                                                        <input type="checkbox" class="filled-in" id="filled-in-box8" value={this.state.tassle} onChange={(e) => this.setState({ tassle: !this.state.tassle })} />
                                                        <label for="filled-in-box8">Tassle</label>
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                        {this.state.aari &&
                                            <div class="col-md-12 no-padding">
                                                <div class="process-title sub_title pl-0 mt-0">Aari</div>
                                                <form name="aariForm">
                                                    <div class="col-md-12 embroid-mul mt-0 mb-2">
                                                        <div class="col-md-2 step-one pl-0">
                                                            <div class="form-group">
                                                                <label for="ref-no">Running Time</label><br />
                                                                <div class="col-md-12 nopadding">
                                                                    <div class="col-md-6" style={{ paddingLeft: "0" }}>
                                                                        <input type="number" min="0" class="form-control" placeholder="hh" name="hh" value={this.state.hh} onChange={(e) => this.setState({ hh: e.target.value })} />
                                                                    </div>
                                                                    <div class="col-md-6" style={{ paddingLeft: "0" }}>
                                                                        <input type="number" min="0" class="form-control" placeholder="mm" name="mm" value={this.state.mm} onChange={(e) => this.setState({ mm: e.target.value })} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 step-one">
                                                            <div class="form-group">
                                                                <label for="phone">Chappa</label>
                                                                <div class="switch switch-mod">
                                                                    <label>
                                                                        No
                                                                            <input class="sample-opt-chckbox" type="checkbox" value={this.state.chappa} onChange={(e) => this.setState({ chappa: !this.state.chappa })} />
                                                                        <span class="lever"></span>
                                                                        yes
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 step-one">
                                                            <div class="form-group">
                                                                <label for="phone">Re-Cut Guide Stitch</label>
                                                                <div class="switch switch-mod">
                                                                    <label>
                                                                        No
                                                                            <input class="sample-opt-chckbox" type="checkbox" value={this.state.reCut} onChange={(e) => this.setState({ reCut: !this.state.reCut })} />
                                                                        <span class="lever"></span>
                                                                        yes
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                        {this.state.manual &&
                                            <div class="col-md-12 no-padding">
                                                <form name="manualForm">
                                                    <div class="process-title sub_title pl-0 mt-0">Manual</div>
                                                    <div class="col-md-12 embroid-mul mt-0 mb-2">
                                                        <div class="col-md-2 step-one pl-0">
                                                            <div class="form-group">
                                                                <label for="ref-no">Time</label><br />
                                                                <div class="col-md-12 nopadding">
                                                                    <div class="col-md-6" style={{ paddingLeft: "0" }}>
                                                                        <input type="number" min="0" class="form-control" placeholder="hh" value={this.state.timehh} onChange={(e) => this.setState({ timehh: e.target.value })} />
                                                                    </div>
                                                                    <div class="col-md-6" style={{ paddingLeft: "0" }}>
                                                                        <input type="number" min="0" class="form-control" placeholder="mm" value={this.state.timemm} onChange={(e) => this.setState({ timemm: e.target.value })} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 step-one">
                                                            <div class="form-group">
                                                                <label for="ref-no">no. Of beads / Sequins</label>
                                                                <select class="form-control" name="" onChange={(e) => this.setState({ numberOfBeads: e.target.value })}>
                                                                    <option value="style">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="6">6</option>
                                                                    <option value="7">7</option>
                                                                    <option value="8">8</option>
                                                                    <option value="9">9</option>
                                                                    <option value="10">10</option>
                                                                    <option value="10-15">10 - 15</option>
                                                                    <option value="15-20">15 - 20</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 hand-req-con">
                                                            <div class="col-md-12 px-0">

                                                                <div className="main-embellishment-trim-box" id="main-embellishment-trim-box">
                                                                    <div className="row">
                                                                        {this.state.manualQty !== undefined && Array.isArray(this.state.manualQty) && this.state.manualQty.length > 0 && this.state.manualQty.map((value, index) =>


                                                                            <div class="col-md-3 size-mngr size-mngr-mod px-1 pr-4 mb-4">
                                                                                <div class="col-4-shadow px-0">
                                                                                    <div class="col-md-6 step-one mb-2">
                                                                                        <div class="form-group">
                                                                                            <label for="address">Trim No</label>
                                                                                            <Async
                                                                                                name="trimId"
                                                                                                value={this.state[`manualTrim${index}`]}
                                                                                                onInputChange={(e) => this.getTrimNumber(e)}
                                                                                                onChange={(e) => this.changeManualTrimNumber(e, index)}
                                                                                                placeholder="Find Trim"
                                                                                                options={this.state.trimNumberInfo}

                                                                                            />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div class="col-md-6 step-one mb-2">
                                                                                        <div class="form-group">
                                                                                            <label for="address">Qty</label>
                                                                                            <input type="text" class="form-control" name="quantity" value={this.state[`manualQtyValue${index}`]} onChange={(e) => this.setState({ [`manualQtyValue${index}`]: e.target.value })} />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div class="col-md-2 add-address">
                                                                                        <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green add-multiple-embellishment-trim-btn" onClick={(e) => this.addEmbellishment(e)}><i class="material-icons">add</i></a>
                                                                                        <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-embellishment-trim-btn" onClick={(e) => this.removeEmbellishment(e, index)}><i className="material-icons">clear</i></a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div style={{ paddingBottom: '15px' }} className="multiple-embellishment-trim-box" id="multiple-embellishment-trim-box">
                                                                </div>

                                                                <div class="second-address-con" style={{ display: "none" }}>
                                                                    <div class="col-md-3 size-mngr size-mngr-mod" style={{ marginBottom: "5px", marginLeft: "15px" }}>
                                                                        <div class="col-md-6 step-one">
                                                                            <div class="form-group">
                                                                                <label for="address">Trim No</label>

                                                                            </div>
                                                                        </div>

                                                                        <div class="col-md-6 step-one">
                                                                            <div class="form-group">
                                                                                <label for="address">Qty</label>
                                                                                <input type="number" min="0" class="form-control" name="quantity" />
                                                                            </div>
                                                                        </div>

                                                                        <div class="add-address">
                                                                            <a class="btn-floating btn-small waves-effect waves-light red sec-close-btn"><i class="material-icons">clear</i></a>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                        {this.state.tassle &&
                                            <div class="col-md-12 no-padding">
                                                <form name="tassleForm">
                                                    <div class="process-title sub_title pl-0 mt-0">Tassle</div>
                                                    <div class="col-md-12 embroid-mul mt-0 mb-2">
                                                        <div class="col-md-3 step-one pl-0">
                                                            <div class="form-group">
                                                                <label for="ref-no">No. Of tassle</label>
                                                                <select class="form-control" name="numberOfTassel" onChange={(e) => this.setState({ numberOfTassel: e.target.value })}>
                                                                    <option value="style">Select</option>
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                    <option value="6">6</option>
                                                                    <option value="7">7</option>
                                                                    <option value="8">8</option>
                                                                    <option value="9">9</option>
                                                                    <option value="10">10</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-2 step-one">
                                                            <div class="form-group">
                                                                <label for="ref-no">Method</label>
                                                                <select class="form-control" name="method" onChange={(e) => this.setState({ method: e.target.value })}>
                                                                    <option value="style">Select</option>
                                                                    {styleInfo !== undefined && styleInfo.LOCATION !== undefined && Array.isArray(styleInfo.LOCATION) && styleInfo.LOCATION.length > 0 && styleInfo.LOCATION.map((style, index) =>
                                                                        <option value={style._id}>{style.name}</option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 step-one">
                                                            <div class="form-group">
                                                                <label for="phone">Beading</label>
                                                                <div class="switch switch-mod">
                                                                    <label>
                                                                        No
                                                                            <input class="sample-opt-chckbox" type="checkbox" value={this.state.beading} onChange={(e) => this.setState({ beading: !this.state.beading })} />
                                                                        <span class="lever"></span>
                                                                        yes
                                                                        </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>}
                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" name="button" onClick={(e) => this.createEmbellishment(e)}>Save</button>
                                            {/* <button type="button" class="primary" name="button">Edit</button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*  EMBELLISHMENT ENDS HERE  */}
                            {/*  CUTTINGS START HERE  */}

                            <div class="card-filter meeting-min-con" id="cutting" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <div class="wash-container">
                                            <form name="cuttingForm">
                                                <div class="col-md-12 no-padding">

                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title pl-3" style={{ paddingBottom: "10px" }}><b>CUTTing</b>
                                                        </h6>

                                                    </div>
                                                    {this.state.cuttingCount !== undefined && Array.isArray(this.state.cuttingCount) && this.state.cuttingCount.length > 0 && this.state.cuttingCount.map((value, index) =>

                                                        <div class="col-md-12 no-padding">
                                                            <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green pull-right mt-3" onClick={(e) => this.addCategoryCount(e, "cuttingCount")}><i class="material-icons">add</i></a>
                                                            <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3" id="del-sample-size-btn" onClick={(e) => this.removeCategoryCount(index, "cuttingCount")}><i className="material-icons">clear</i></a>
                                                            <div class="col-md-3 step-one">
                                                                <div class="form-group no-padding">
                                                                    <label for="ref-no">Cutting Master Name</label>
                                                                    <Async
                                                                        name="cuttingMaster"
                                                                        value={this.state[`cuttingMaster${index}`]}
                                                                        onInputChange={(e) => this.getPatternMaster(e, "cuttingMaster")}
                                                                        onChange={(e) => this.changeCuttingMasterDynamic(e, index)}
                                                                        placeholder="Find Style"
                                                                        options={this.state.patternMasterInfo}

                                                                    />


                                                                </div>
                                                            </div>
                                                            <div class="col-md-3 step-one">
                                                                <div class="form-group">
                                                                    <label for="">Date</label>
                                                                    <input type="date" class="form-control" name="date" />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-3 step-one">
                                                                <div class="form-group">
                                                                    <label for="">Any Pattern Issues?</label>
                                                                    <input type="text" class="form-control" name="patternIssues" />
                                                                </div>
                                                            </div>

                                                            <div class="col-md-2 step-one">
                                                                <div class="form-group">
                                                                    <label for="">Any Fabric Issues?</label>
                                                                    <div class="switch switch-mod">
                                                                        <label>
                                                                            <input class="sample-opt-chckbox" type="checkbox" id={"fabricIssue" + index} value={this.state[`fabricIssue${index}`]} onChange={(e) => this.checkboxChange(e)} />
                                                                            <span class="lever"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </form>


                                        </div>



                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" name="button" onClick={(e) => this.createCutting(e)}>Save</button> <button type="button" class="primary" name="button" onClick={(e) => this.completeCutting(e)}>Complete</button>
                                            {/* <!-- <button type="button" class="primary" name="button">generate report</button>  --> */}

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*  CUTTINGS ENDS HERE  */}
                            {/*  SEWING STARTS HERE  */}

                            <div class="card-filter meeting-min-con" id="sewing" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <form name="sewingForm">
                                            <div class="wash-container">
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title pl-3" style={{ paddingBottom: "10px" }}><b>Sewing</b></h6>
                                                    </div>

                                                    {this.state.sewingCount !== undefined && Array.isArray(this.state.sewingCount) && this.state.sewingCount.length > 0 && this.state.sewingCount.map((value, index) =>
                                                        <div>
                                                            <div class="col-md-11 no-padding">
                                                                <div class="row">
                                                                    <div class="col-md-2 step-one">
                                                                        <div class="form-group no-padding">
                                                                            <label for="ref-no"> Tailor Name</label>
                                                                            <br />
                                                                            <Async
                                                                                name="tailerId"
                                                                                value={this.state[`patternMaster${index}`]}
                                                                                onInputChange={(e) => this.getPatternMaster(e, "patternMaster")}
                                                                                onChange={(e) => this.changePatternMasterDynamic(e, index)}
                                                                                placeholder="Find Style"
                                                                                options={this.state.patternMasterInfo}

                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2 step-one">
                                                                        <div class="form-group">
                                                                            <label for="ref-no">Size</label>
                                                                            <input type="number" min="0" class="form-control" name="size" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2 step-one">
                                                                        <div class="form-group">
                                                                            <label for="ref-no">Qty</label>
                                                                            <input type="number" min="0" class="form-control" name="quantity" />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2 step-one">
                                                                        <div class="form-group">
                                                                            <label for="ref-no">Status</label>
                                                                            <select class="form-control" name="status">
                                                                                <option value="">Select</option>
                                                                                <option value="pending">Pending</option>
                                                                                <option value="completed">Completed</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-2 step-one">
                                                                        <div class="form-group">
                                                                            <label for="">Date</label>
                                                                            <input type="date" class="form-control" name="date" />
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div class="col-md-1 step-one">
                                                                <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green pull-right mt-3" onClick={(e) => this.addCategoryCount(e, "sewingCount")}><i class="material-icons">add</i></a>
                                                                <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3" id="del-sample-size-btn" onClick={(e) => this.removeCategoryCount(index, "sewingCount")}><i className="material-icons">clear</i></a>
                                                            </div>
                                                        </div>
                                                    )}


                                                </div>
                                            </div>
                                            <div class="col-md-12 no-padding text-center profile-btn">
                                                <button type="button" class="primary" name="button" onClick={(e) => this.createSewing(e)}>save</button> <button type="button" class="primary" name="button" onClick={(e) => this.completeSewing()}>Complete</button>
                                                {/* <!-- <button type="button" class="primary" name="button">generate report</button>  --> */}

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/*  SEWING ENDS HERE  */}
                            {/*  DISPATCH STARTS HERE  */}
                            <div class="card-filter meeting-min-con" id="dispatch" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <div class="wash-container">
                                            <form id="dispatchForm">
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-12 no-padding">
                                                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}><b>Dispatch</b>

                                                        </h6>
                                                    </div>
                                                    {this.state.dispatchCount !== undefined && Array.isArray(this.state.dispatchCount) && this.state.dispatchCount.length > 0 && this.state.dispatchCount.map((value, index) =>
                                                        <Fragment>
                                                            <div>
                                                                <div class="col-md-11 no-padding" style={{ marginBottom: " 15px" }}>
                                                                    <div class="row">
                                                                        <div class="col-md-2 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">Location</label>
                                                                                <br />
                                                                                <select class="form-control" name="location">
                                                                                    <option value="cust">Select</option>
                                                                                    {styleInfo !== undefined && styleInfo.LOCATION !== undefined && Array.isArray(styleInfo.LOCATION) && styleInfo.LOCATION.length > 0 && styleInfo.LOCATION.map((style, index) =>
                                                                                        <option value={style._id}>{style.name}</option>
                                                                                    )}
                                                                                </select>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-md-2 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">Courier</label>
                                                                                <br />
                                                                                <select class="form-control" name="courier">
                                                                                    <option value="cust">Select</option>
                                                                                    {styleInfo !== undefined && styleInfo.COURIER !== undefined && Array.isArray(styleInfo.COURIER) && styleInfo.COURIER.length > 0 && styleInfo.COURIER.map((style, index) =>
                                                                                        <option value={style._id}>{style.name}</option>
                                                                                    )}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-2 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">AWB No.</label>
                                                                                <br />
                                                                                <input type="number" min="0" class="form-control" name="awbNumber" />
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-2 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">Date</label>
                                                                                <input type="date" class="form-control" name="date" />
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-3 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">Attention</label>
                                                                                <select class="form-control" name="attention">
                                                                                    <option value="">Select</option>
                                                                                    {styleInfo !== undefined && styleInfo.ATTENTION !== undefined && Array.isArray(styleInfo.ATTENTION) && styleInfo.ATTENTION.length > 0 && styleInfo.ATTENTION.map((style, index) =>
                                                                                        <option value={style._id}>{style.name}</option>
                                                                                    )}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-1 step-one">
                                                                            <div class="form-group">
                                                                                <label for="phone">Magnum</label>
                                                                                <div class="switch switch-mod">
                                                                                    <label>
                                                                                        <input class="sample-opt-chckbox" type="checkbox" id={"magnum" + index} value={this.state[`magnum${index}`]} onChange={(e) => this.checkboxChange(e)} />
                                                                                        <span class="lever"></span>
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-2 step-one">
                                                                            <div class="form-group">
                                                                                <label for="ref-no">ETA</label>
                                                                                <input type="date" class="form-control" name="date" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-1">

                                                                    <a style={index === 0 ? { display: "block" } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green pull-right mt-3" onClick={(e) => this.addCategoryCount(e, "dispatchCount")}><i class="material-icons">add</i></a>
                                                                    <a style={index !== 0 ? { display: "block" } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right mt-3" id="del-sample-size-btn" onClick={(e) => this.removeCategoryCount(index, "dispatchCount")}><i className="material-icons">clear</i></a>
                                                                </div>
                                                            </div>
                                                            <div class="samp-req-con">
                                                                <div class="col-md-12 px-1">

                                                                    <div className="main-dispatch-size-box mb-3" id="main-dispatch-size-box">
                                                                        <div className="row">
                                                                            {this.state.dispatchQty !== undefined && Array.isArray(this.state.dispatchQty) && this.state.dispatchQty.map((value, index) =>
                                                                                <div class="col-md-4 size-mngr size-mngr-mod px-1" style={{ marginBottom: "5px" }}>
                                                                                    <div class="col-4-shadow">
                                                                                        <div class="col-md-6 step-one mb-3">
                                                                                            <div class="form-group">
                                                                                                <label for="address">Size</label>
                                                                                                <select class="form-control select-box-min" name="size" >
                                                                                                    <option value="slct">Select</option>
                                                                                                    <option value={1}>1</option>
                                                                                                    <option value={2}>2</option>
                                                                                                    <option value={3}>3</option>
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-6 step-one mb-3">
                                                                                            <div class="form-group">
                                                                                                <label for="address">Qty</label>
                                                                                                <input type="number" min="0" class="form-control" name="quantity" />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-md-2 add-address">
                                                                                            <a style={index === 0 ? { display: 'block' } : { display: "none" }} class="btn-floating btn-small waves-effect waves-light green add-multiple-sample-size-btn" onClick={(e) => this.addSizeForDispatch(e)}><i class="material-icons">add</i></a>
                                                                                            <a style={index !== 0 ? { display: 'block' } : { display: "none" }} className="btn-floating btn-small waves-effect waves-light red del-sample-size-btn" onClick={(e) => this.removeSizeForDispatch(e, index)}><i className="material-icons">clear</i></a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className='multiple-dispatch-size-box' id="multiple-dispatch-size-box"></div>
                                                                </div>
                                                            </div>
                                                        </Fragment>
                                                    )}
                                                </div>
                                            </form>

                                        </div>

                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" name="button" onClick={(e) => this.createDispatch(e)}>Save</button> <button type="button" class="primary" name="button" onClick={(e) => this.completeDispatch(e)}>Complete</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/*  DISPATCH ENDS HERE  */}
                            {/* SIGN OFF STARTS HERE */}
                            <div class="card-filter meeting-min-con" id="sign-off" style={{ marginBottom: ".5%", display: "none" }}>
                                <div class="row">
                                    <div class="col-md-12 product-form" style={{ paddingBottom: "1%" }}>
                                        <div class="wash-container">
                                            <div class="col-md-12 no-padding">
                                                <div class="col-md-12 no-padding">
                                                    <h6 class="dev-title pl-3" style={{ paddingBottom: "10px" }}><b>Sign Off</b></h6>
                                                </div>
                                                <div class="col-md-12 no-padding">
                                                    <div class="col-md-3 step-one">
                                                        <div class="form-group">
                                                            <label for="ref-no">Merchandiser Name</label>
                                                            <br />
                                                            <Async
                                                                name="patternMaster"
                                                                value={this.state.patternMaster}
                                                                onInputChange={(e) => this.getPatternMaster(e, "merchandiser")}
                                                                onChange={this.changePatternMaster}
                                                                placeholder="Find Style"
                                                                options={this.state.patternMasterInfo}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 step-one">
                                                        <Field
                                                            isFormGroup={true}
                                                            inputType='date'
                                                            value={this.state.signOffDate}
                                                            inputName={`signOffDate`}
                                                            label='Date'
                                                            onChange={this.updateDate}
                                                            disabled={this.state.disabled}
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 no-padding text-center profile-btn">
                                            <button type="button" class="primary" onClick={(e) => this.createSignOff(e)} name="button">save</button> <button type="button" class="primary" name="button" onClick={(e) => this.completeSignOff(e)}>Complete</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* SIGN OFF ENDS HERE */}
                        </div>
                    </div>

                    <Modal open={this.state.openModal} onClose={() => this.setState({ openModal: false })} s center>
                        <img src={this.state.imageForModal !== "" && window.URL.createObjectURL(this.state.imageForModal)} style={{ width: '100%' }} />
                    </Modal>
                </div>

                <div id="myModal" class="modal fade" role="dialog">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-body no-padding">
                                <div class="meeting-min-con">
                                    <div class="row">
                                        <div class="col-md-12 no-padding">
                                            <div class="col-md-8 product-form no-padding">
                                                <div class="col-md-6 nopadding">
                                                    <div class="col-md-12 step-one">
                                                        <div class="form-group">
                                                            <label for="phone">Search Style</label><br />
                                                            <span>BY</span>
                                                            <br />
                                                            <select class="form-control" name="" onChange={(e) => this.setState({ searchMeetingNotesBy: e.target.value })}>
                                                                <option value="style">Select</option>
                                                                <option value="MNId">Meeting Notes No</option>
                                                                <option value="customerName">Customer Name</option>
                                                                <option value="customerDepartment">Departement Name</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 no-padding">
                                                    <div class="col-md-12 step-one ">
                                                        <div class="form-group">
                                                            <label for="ref-no"></label><br />
                                                            <span>FOR</span>
                                                            <br />
                                                            <input type="text" class="form-control" name="meetingNoteValue" value={this.state.meetingNoteValue} onChange={(e) => this.setState({ meetingNoteValue: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 product-form">
                                                <div class="col-md-12 mm-btns" style={{ marginTop: "20%" }}>
                                                    <button type="button" class="primary" name="button" onClick={(e) => this.searchMeetingNote(e)}>Search</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 no-padding">
                                            <div class="table-container">
                                                <table class="striped">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="num">Meeting Notes No</th>
                                                            <th data-field="name">Customer Name</th>
                                                            <th data-field="name">Deptartment Name</th>
                                                            <th data-field="act">Action</th>
                                                            <th data-field="select">Select</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.meetingNotes !== undefined && Array.isArray(this.state.meetingNotes) && this.state.meetingNotes.length > 0 && this.state.meetingNotes.map((meetingNote, index) =>
                                                            <tr>
                                                                <td>{meetingNote.MNId !== null && meetingNote.MNId}</td>
                                                                <td>{meetingNote.customerName !== null && meetingNote.customerName}</td>
                                                                <td>{meetingNote.customerDepartmentName !== null && meetingNote.customerDepartmentName}</td>
                                                                <td>
                                                                    <a href="" class="view" title="View" onClick={() => this.props.history.push('/viewMeeting?' + meetingNote._id)}>
                                                                        <i class="material-icons">visibility</i>
                                                                    </a>


                                                                </td>
                                                                <td> <input type="radio" name="gender" class="sourcingOption" data-dismiss="modal" onClick={() => this.setState({ MNId: meetingNote.MNId, meetingNoteId: meetingNote._id })} /><br /></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default DevelopmentProduct;

{/* <script type="text/javascript">
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    });
  </script> */}




// WEBPACK FOOTER //
// ./src/pages/developmentProduct/page.js